import {
  MAX_PAYMENT_METHODS,
  MAX_CASHBACK_METHODS,
  campaignContactOptions,
} from '../helpers/options';

export const inboxTableHeader = [
  { name: 'N° orden', value: 'orderNumber', sortable: false },
  { name: 'Fecha', value: 'date', sortable: false },
  { name: 'Notificación', value: 'notification', sortable: false },
  { name: 'Asesor responsable', value: 'advisor', sortable: false },
  { name: 'Acción', value: 'action', sortable: false },
];

export const craneTableheader = [
  { name: 'Empresa', value: 'name', sortable: false },
  { name: 'Nombre de contacto', value: 'contact', sortable: false },
  { name: 'Teléfono', value: 'phone', sortable: false }, //   { name: 'Región', value: 'region' },
  { name: 'Identificación', value: 'identification', sortable: false },
  { name: 'Estado', value: 'state', sortable: false },
  { name: 'Estatus', value: 'status', sortable: false },
  { name: 'Acción', value: 'table-action', sortable: false },
];

export const saleUsersTableheader = [
  { name: 'Nombres', value: 'name', sortable: false },
  { name: 'Email', value: 'contact', sortable: false },
  { name: 'Perfil', value: 'phone', sortable: false }, //   { name: 'Región', value: 'region' },
  { name: 'Canal de Venta', value: 'contact', sortable: false },
  { name: 'Status', value: 'state', sortable: false },
  { name: 'Creado', value: 'status', sortable: false },
  { name: 'Modificado', value: '', sortable: false },
  { name: 'Acción', value: '', sortable: false },
];

export const giftCardPaymentsHeader = [
  { name: 'Tipo', value: 'name', sortable: false },
  { name: 'Monto USD', value: 'name', sortable: false },
  { name: 'Monto BsS', value: 'name', sortable: false },
  { name: 'Metodo', value: 'name', sortable: false },
  { name: 'Estatus de pago', value: 'name', sortable: false },
  { name: 'Referencia', value: 'name', sortable: false },
  { name: 'Titular de la cuenta', value: 'name', sortable: false },
  { name: 'Caja de venta', value: 'name', sortable: false },
  { name: 'Ver comprobante', value: 'name', sortable: false },
  { name: 'Fecha de Pago', value: 'name', sortable: false },
  { name: 'Accion', value: 'name', sortable: false },
];

export const saleChannelTableheader = [
  { name: 'Nombre', value: 'name', sortable: false },
  { name: 'Correlativo de trazabilidad', value: 'name', sortable: false },
  { name: 'F2 Link', value: 'name', sortable: false },
  { name: 'F4 Link', value: 'name', sortable: false },
  { name: 'Retail Link', value: 'name', sortable: false },
  { name: 'QR F2', value: 'name', sortable: false },
  { name: 'QR', value: 'name', sortable: false },
  { name: 'QR PlusF4', value: 'name', sortable: false },
  { name: 'Status', value: 'contact', sortable: false },
];

export const salePricesTableheader = [
  { name: '', value: 'name', sortable: false },
  { name: 'Classic', value: 'name', sortable: false },
  { name: 'Plus', value: 'name', sortable: false },
  { name: 'Gold', value: 'name', sortable: false },
  { name: 'Motorider', value: 'name', sortable: false },
];

export const paymentsTableHeader = [
  { name: 'Tipo', value: 'name', sortable: false },
  { name: 'Monto USD', value: 'name', sortable: false },
  { name: 'Monto BsS', value: 'name', sortable: false },
  { name: 'Metodo', value: 'name', sortable: false },
  { name: 'Estatus de pago', value: 'name', sortable: false },
  { name: 'Tipo de pago', value: 'name', sortable: false },
  { name: 'Referencia', value: 'name', sortable: false },
  { name: 'Lote de transacción', value: 'name', sortable: false },
  { name: 'Titular de la cuenta', value: 'name', sortable: false },
  { name: 'Caja de venta', value: 'name', sortable: false },
  { name: 'Ver comprobante', value: 'name', sortable: false },
  { name: 'Fecha de Pago', value: 'name', sortable: false },
  { name: 'Ordenes Asociadas', value: 'name', sortable: false },
  { name: 'Observaciones', value: 'name', sortable: false },
  { name: 'Accion', value: 'name', sortable: false },
];

export const casheaPaymentsTableHeader = [
  { name: 'Tipo', value: 'name', sortable: false },
  { name: 'Monto USD', value: 'name', sortable: false },
  { name: 'Monto BsS', value: 'name', sortable: false },
  { name: 'Metodo', value: 'name', sortable: false },
  { name: 'Estatus de pago', value: 'name', sortable: false },
  { name: 'Tipo de pago', value: 'name', sortable: false },
  { name: 'Referencia', value: 'name', sortable: false },
  { name: 'Lote de transacción', value: 'name', sortable: false },
  { name: 'Titular de la cuenta', value: 'name', sortable: false },
  { name: 'Caja de venta', value: 'name', sortable: false },
  { name: 'Referencia de Cashea', value: 'name', sortable: false },
  { name: 'Ver comprobante', value: 'name', sortable: false },
  { name: 'Fecha de Pago', value: 'name', sortable: false },
  { name: 'Ordenes Asociadas', value: 'name', sortable: false },
  { name: 'Accion', value: 'name', sortable: false },
];

export const ChangeTableHeader = [
  { name: 'Tipo', value: 'name', sortable: false },
  { name: 'Monto USD', value: 'name', sortable: false },
  { name: 'Monto BsS', value: 'name', sortable: false },
  { name: 'Metodo', value: 'name', sortable: false },
  { name: 'Referencia', value: 'name', sortable: false },
  { name: 'Datos del Vuelto', value: 'name', sortable: false },
  { name: 'Ver comprobante', value: 'name', sortable: false },
  { name: 'Fecha de Pago', value: 'name', sortable: false },
  { name: 'Observación', value: 'name', sortable: false },
  { name: 'Accion', value: 'name', sortable: false },
];

export const pendingPaymentsTableHeader = [
  { name: 'Tipo', value: 'name', sortable: false },
  { name: 'Monto Total USD', value: 'name', sortable: false },
  { name: 'Monto Total BsS', value: 'name', sortable: false },
  { name: 'Estatus de pago', value: 'name', sortable: false },
  { name: 'Fecha de Corte', value: 'name', sortable: false },
  { name: 'Ref Cashea', value: 'name', sortable: false, isOnlyCashea: true },
  { name: 'Ordenes Asociadas', value: 'name', sortable: false },
  { name: 'Accion', value: 'name', sortable: false },
];

export const fleetsTableheader = [
  { name: 'Transporte', value: 'name', sortable: false },
  { name: 'Modelo', value: 'contact', sortable: false },
  { name: 'Marca', value: 'phone', sortable: false }, //   { name: 'Región', value: 'region' },
  { name: 'Placa', value: 'state', sortable: false },
  { name: 'Año', value: 'status', sortable: false },
  { name: 'Fecha de Compra', value: '', sortable: false },
  { name: 'Acción', value: '', sortable: false },
];
export const searchInternalProviderTableHeader = [
  { name: '', value: 'plus', sortable: false },
  { name: 'Nombre', value: 'name', sortable: false },
  { name: 'Teléfono', value: 'phone', sortable: false }, //   { name: 'Región', value: 'region' },
  { name: 'Identificación', value: 'contact', sortable: false },
  { name: 'Estado', value: 'state', sortable: false },
  { name: 'Estatus', value: 'status', sortable: false },
  { name: 'Acción', value: '', sortable: false },
];
export const internalProviderTableHeader = [
  { name: 'Nombre', value: 'name', sortable: false },
  { name: 'Tipo', value: 'type', sortable: false },
  { name: 'Teléfono', value: 'phone', sortable: false }, //   { name: 'Región', value: 'region' },
  { name: 'Identificación', value: 'contact', sortable: false },
  { name: 'Estado', value: 'state', sortable: false },
  { name: 'Estatus', value: 'status', sortable: false },
  { name: 'Acción', value: '', sortable: false },
];

export const vehicularAssetsTableHeader = [
  { name: 'Transporte', value: 'name', sortable: false },
  { name: 'Marca', value: 'contact', sortable: false },
  { name: 'Modelo', value: 'phone', sortable: false }, //   { name: 'Región', value: 'region' },
  { name: 'Color', value: 'color', sortable: false },
  { name: 'Placa', value: 'state', sortable: false },
  { name: 'Año', value: 'status', sortable: false },
  { name: 'Fecha de Compra', value: 'status', sortable: false },
  { name: 'Descripción', value: '', sortable: false },
  { name: 'Acción', value: '', sortable: false },
];

export const providersTableheader = [
  { name: '', value: '', sortable: false },
  { name: 'Empresa', value: 'name', sortable: false },
  { name: 'Nombre de contacto', value: 'contact', sortable: false },
  { name: 'Teléfono', value: 'phone', sortable: false },
  { name: 'Identificación', value: 'identification', sortable: false },
  { name: 'Estado', value: 'region', sortable: false },
  { name: 'Estatus', value: 'status', sortable: false },
];

export const serviceHistoryTableheader = [
  { name: 'Fecha', value: 'date', sortable: false },
  { name: 'Averia', value: 'fault', sortable: false },
  { name: 'Servicio', value: '', sortable: false }, //   { name: 'Región', value: 'region' },
  { name: 'Km', value: 'KMEfectivo', sortable: false },
];

export const paymentPlanTableHeader = [
  { name: 'Nro. pago', value: 'date', sortable: false },
  { name: 'Fecha', value: 'fault', sortable: false },
  { name: 'Monto (USD)', value: '', sortable: false }, //   { name: 'Región', value: 'region' },
  { name: 'Cumplimiento', value: 'KMEfectivo', sortable: false },
  { name: '', value: 'KMEfectivo', sortable: false },
];

export const exportanblesTableheader = [
  { name: 'Operador', value: 'name', sortable: false },
  { name: 'Nro. de caso', value: 'contact', sortable: false },
  { name: 'Fecha de creación', value: 'phone', sortable: false }, //   { name: 'Región', value: 'region' },
  { name: 'Hora de creación', value: 'status', sortable: false },
  { name: 'Estatus', value: 'state', sortable: false },
  { name: 'Nombre', value: '', sortable: false },
  { name: 'Apellido', value: '', sortable: false },
  { name: 'Placa', value: '', sortable: false },
  { name: 'Marca', value: '', sortable: false },
  { name: 'Modelo', value: '', sortable: false },
  { name: 'Año', value: '', sortable: false },
  { name: 'Plan', value: '', sortable: false },
  { name: 'Estatus de Afiliación', value: '', sortable: false },
  { name: 'Tipo de gestión', value: '', sortable: false },
  { name: 'Avería', value: '', sortable: false },
  { name: 'Avería Real', value: '', sortable: false },
  { name: 'Estado origen', value: '', sortable: false },
  { name: 'Ciudad origen', value: '', sortable: false },
  { name: 'Estado destino', value: '', sortable: false },
  { name: 'Ciudad destino', value: '', sortable: false },
];

export const imageHeader = [
  {
    name: `Imagen AV`,
    value: '',
    sortable: false,
    hidePrint: true,
  },
  {
    name: `Imagen grúa 1`,
    value: '',
    sortable: false,
    hidePrint: true,
  },
  {
    name: `Imagen grúa 2`,
    value: '',
    sortable: false,
    hidePrint: true,
  },
  {
    name: `Imagen grúa 3`,
    value: '',
    sortable: false,
    hidePrint: true,
  },
];

export const stageTimeHeader = [
  {
    name: `Tiempo AV Asignado`,
    value: '',
    sortable: false,
  },
  {
    name: `Tiempo AV en vía`,
    value: '',
    sortable: false,
  },
  {
    name: `Tiempo AV en origen`,
    value: '',
    sortable: false,
  },
  {
    name: `Tiempo en búsqueda grúa`,
    value: '',
    sortable: false,
  },
  {
    name: `Tiempo grúa asginada`,
    value: '',
    sortable: false,
  },
  {
    name: `Tiempo grúa en vía`,
    value: '',
    sortable: false,
  },
  {
    name: `Tiempo en grúa en origen`,
    value: '',
    sortable: false,
  },
  {
    name: `Tiempo cliente vía destino`,
    value: '',
    sortable: false,
  },
  {
    name: `Tiempo total gestión`,
    value: '',
    sortable: false,
  },
];

export const AVPaymentHeader = [
  { name: 'Chofer', value: 'name', sortable: false },
  { name: 'Fecha de servicio', value: 'contact', sortable: false },
  { name: 'Servicio Prestado', value: 'phone', sortable: false }, //   { name: 'Región', value: 'region' },
  { name: 'Tipo de gestión', value: 'state', sortable: false },
  { name: 'Código de servicio', value: 'status', sortable: false },
  { name: 'Placa', value: 'state', sortable: false },
  { name: 'Marca', value: '', sortable: false },
  { name: 'Estado origen', value: '', sortable: false },
  { name: 'Ciudad origen', value: '', sortable: false },
  { name: 'Costo del servicio', value: '', sortable: false },
  { name: 'Monto pagado al chofer', value: '', sortable: false },
];

export const internalTowPaymentHeader = [
  { name: 'Chofer', value: 'name', sortable: false },
  { name: 'Fecha de servicio', value: 'contact', sortable: false },
  { name: 'Servicio Prestado', value: 'phone', sortable: false }, //   { name: 'Región', value: 'region' },
  { name: 'Tipo de gestión', value: 'state', sortable: false },
  { name: 'Código de servicio', value: 'status', sortable: false },
  { name: 'Placa', value: '', sortable: false },
  { name: 'Marca', value: '', sortable: false },
  { name: 'Estado origen', value: '', sortable: false },
  { name: 'Ciudad origen', value: '', sortable: false },
  { name: 'Costo del servicio', value: '', sortable: false },
  { name: 'Monto pagado al chofer', value: '', sortable: false },
];

export const externalTowPaymentHeader = [
  { name: 'Chofer', value: 'name', sortable: false },
  { name: 'Fecha de servicio', value: 'contact', sortable: false },
  { name: 'Servicio Prestado', value: 'phone', sortable: false }, //   { name: 'Región', value: 'region' },
  { name: 'Tipo de gestión', value: 'state', sortable: false },
  { name: 'Código de servicio', value: 'status', sortable: false },
  { name: 'Placa', value: '', sortable: false },
  { name: 'Marca', value: '', sortable: false },
  { name: 'Estado origen', value: '', sortable: false },
  { name: 'Ciudad origen', value: '', sortable: false },
  { name: 'Costo del servicio', value: '', sortable: false },
  { name: 'Monto pagado al chofer', value: '', sortable: false },
];

export const fleetloadTableHeader = [
  { name: 'ID', value: 'name', sortable: true },
  { name: 'Nombre', value: 'contact', sortable: true },
  { name: 'Código', value: 'phone', sortable: true }, //   { name: 'Región', value: 'region' },
  { name: 'Status', value: 'state', sortable: true },
  { name: 'Cargas', value: 'status', sortable: true },
  { name: 'Creado', value: '', sortable: false },
  { name: 'Modificado', value: '', sortable: false },
  { name: 'Acciones', value: 'state', sortable: false },
];

export const fleetloadCargoTableHeader = [
  { name: 'Nro. Flota', value: 'name', sortable: true },
  { name: 'Tipo de flota', value: 'contact', sortable: true },
  { name: 'Modo de aplicación', value: 'phone', sortable: true }, //   { name: 'Región', value: 'region' },
  { name: 'Valor de la flota', value: 'state', sortable: true },
  { name: 'Tipo de pago', value: 'status', sortable: true },
  { name: 'Fecha inicio', value: '', sortable: false },
  { name: 'Fecha fin', value: '', sortable: false },
  { name: 'Teléfono', value: 'state', sortable: false },
  { name: 'Cantidad de vehículos', value: 'state', sortable: false },
  { name: 'Status', value: 'state', sortable: false },
  { name: '', value: 'state', sortable: false },
];

export const vehicleChangeHistoryHeader = [
  { name: 'Fecha del cambio', sortable: true },
  { name: 'Asesor Responsable', sortable: true },
  { name: 'Placa Vehiculo Anterior', sortable: true }, //   { name: 'Región', value: 'region' },
  { name: 'Marca Vehiculo Anterior', sortable: true },
  { name: 'Modelo Vehiculo Anterior', sortable: true },
  {
    name: 'Serial carroceria Vehiculo Anterior',
    sortable: false,
  },
  { name: 'Color Vehiculo Anterior', sortable: true },
];

export const customerChangeHistoryHeader = [
  { name: 'Fecha del cambio', sortable: true },
  { name: 'Asesor Responsable', sortable: true },
  { name: 'Cliente Anterior', sortable: true }, //   { name: 'Región', value: 'region' },
  { name: 'CI/RIF Cliente Anterior', sortable: true },
  { name: 'Correo Cliente Anterior', sortable: true },
  { name: 'Telefono Cliente Anterior', sortable: false },
];

export const fleetloadCargoDetailTableHeader = [
  { name: 'Linea', value: 'name', sortable: true },
  { name: 'Tipo', value: 'contact', sortable: true },
  { name: 'Nac', value: 'phone', sortable: true }, //   { name: 'Región', value: 'region' },
  { name: 'Cédula', value: 'state', sortable: true },
  { name: 'Nombre', value: 'status', sortable: true },
  { name: 'Apellido', value: '', sortable: false },
  { name: 'Prefijo', value: '', sortable: false },
  { name: 'Teléfono', value: 'state', sortable: false },
  { name: 'Fec. Nac', value: 'state', sortable: false },
  { name: 'Sexo', value: 'state', sortable: false },
  { name: 'Estado Cobertura', value: 'state', sortable: false },
];

export const fleetloadCargoDetailMockup = [
  {
    name1: '1',
    name2: 'Renovación',
    name3: 'V',
    name4: '23.123.456',
    name5: 'Jose',
    name6: 'Perez',
    name7: '212',
    name8: '3124421',
    name9: 'N/A',
    name10: 'N/A',
    name11: 'Miranda',
  },
  {
    name1: '1',
    name2: 'Renovación',
    name3: 'V',
    name4: '23.123.456',
    name5: 'Jose',
    name6: 'Perez',
    name7: '212',
    name8: '3124421',
    name9: 'N/A',
    name10: 'N/A',
    name11: 'Miranda',
  },
  {
    name1: '1',
    name2: 'Renovación',
    name3: 'V',
    name4: '23.123.456',
    name5: 'Jose',
    name6: 'Perez',
    name7: '212',
    name8: '3124421',
    name9: 'N/A',
    name10: 'N/A',
    name11: 'Miranda',
  },
  {
    name1: '1',
    name2: 'Renovación',
    name3: 'V',
    name4: '23.123.456',
    name5: 'Jose',
    name6: 'Perez',
    name7: '212',
    name8: '3124421',
    name9: 'N/A',
    name10: 'N/A',
    name11: 'Miranda',
  },
];

export const historyPaymentTableHeader = [
  { name: 'Nro. pago', value: 'name', sortable: false },
  { name: 'Fecha', value: 'contact', sortable: false },
  { name: 'Monto (USD)', value: 'phone', sortable: false },
  { name: 'Cumplimiento', value: 'state', sortable: false },
];
export const historyPaymentMockup = [
  {
    name1: '1',
    name2: '31/03/2023',
    name3: '100',
    name4: 'Pago realizado',
  },
  {
    name1: '1',
    name2: '31/03/2023',
    name3: '100',
    name4: 'Pago realizado',
  },
  {
    name1: '1',
    name2: '31/03/2023',
    name3: '100',
    name4: 'Pago realizado',
  },
  {
    name1: '1',
    name2: '31/03/2023',
    name3: '100',
    name4: 'Pago realizado',
  },
  {
    name1: '1',
    name2: '31/03/2023',
    name3: '100',
    name4: 'Pago realizado',
  },
];

export const exportableMockup = [
  {
    operator: 'Manuel Hernandez',
    time: '3:20pm',
    date: '12/03/2023',
    status: 'ACTIVO',
    caseId: '123467789',
    name: 'Luis',
    lastName: 'Perez',
  },
  {
    operator: 'Manuel Hernandez',
    time: '3:20pm',
    date: '12/03/2023',
    status: 'ACTIVO',
    caseId: '123467789',
    name: 'Luis',
    lastName: 'Perez',
  },
  {
    operator: 'Manuel Hernandez',
    time: '3:20pm',
    date: '12/03/2023',
    status: 'ACTIVO',
    caseId: '123467789',
    name: 'Luis',
    lastName: 'Perez',
  },
  {
    operator: 'Manuel Hernandez',
    time: '3:20pm',
    date: '12/03/2023',
    status: 'ACTIVO',
    caseId: '123467789',
    name: 'Luis',
    lastName: 'Perez',
  },
];

export const caseFollowingheader = [
  { name: 'Fecha', value: 'date', sortable: false },
  { name: 'Hora', value: 'fault', sortable: false },
  { name: 'Status', value: '', sortable: false }, //   { name: 'Región', value: 'region' },
  { name: 'Tipo de seguimiento', value: 'observations', sortable: false },
  { name: 'Mensaje', value: 'KMEfectivo', sortable: false },
  { name: 'Observaciones', value: 'KMEfectivo', sortable: false },
];

export const scaseFollowingMockup = [
  {
    date: '04/03/2023',
    time: '09:33:01 A.M.',
    status: 'En espera de AV',
    type: 'Lllamada',
    mesage: 'En vía',
    observations: 'N/A',
  },
];

export const trazeHeader = [
  { name: 'Fecha', value: 'date', sortable: false },
  { name: 'Hora', value: 'fault', sortable: false },
  { name: 'Status', value: '', sortable: false }, //   { name: 'Región', value: 'region' },
  { name: 'Duración', value: 'observations', sortable: false },
];

export const trazeMockup = [
  {
    date: '04/03/2023',
    time: '10:45:01 A.M.',
    statusOrigin: '',
    statusDestiny: 'en espera AV',
    estimatedTime: 'min',
    observations: 'N/A',
  },
  {
    date: '13/03/23',
    time: '07:36:01 A.M.',
    statusOrigin: '',
    statusDestiny: 'en espera AV',
    estimatedTime: 'min',
    observations: 'N/A',
  },
];

export const bikeTableheader = [
  { name: 'Nombre', value: 'name', sortable: false },
  { name: 'Cédula', value: 'cedula', sortable: false },
  { name: 'Teléfono', value: 'phone', sortable: false },
  { name: 'Moto asignada (placa)', value: 'plate', sortable: false },
  { name: 'Estado', value: 'state', sortable: false },
  { name: 'Fecha de creación', value: 'date', sortable: false },
  { name: 'Acción', value: '', sortable: false },
];

export const bikeProvidersMockup = [
  {
    name: 'Jose Luis Perez Rodriguez',
    contact: 'MANUEL HERNANDEZ',
    phone: '1234 567 789',
    state: 'MIRANDA',
    status: 'ACTIVO',
    edit: '',
  },
];

const salesPaymentInitial = (methods) => {
  let header = [];

  for (let i = 1; i <= methods; i++) {
    header.push(
      { name: `Pago Inicial Monto pagado ${i} USD` },
      { name: `Pago Inicial Monto pagado ${i} Bs` },
      { name: `Pago Inicial Método ${i}` },
      { name: `Pago Inicial Referencia ${i}` },
      { name: `Pago Inicial Titular de la cuenta ${i}` }
    );
  }
  return header;
};
export const casheaBDAffiliationQuotas = (quotas) => {
  let header = [];

  for (let i = 1; i <= quotas; i++) {
    header.push(
      // { name: `Fecha de vencimiento Cuota ${i}` },
      { name: `Cashea ${i} Monto pagado USD` },
      { name: `Cashea ${i} Monto pagado Bs` },
      { name: `Cashea Fecha de pago ${i}` },
      { name: `Cashea ${i} Método` },
      { name: `Cashea ${i} Referencia` },
      { name: `Cashea ${i} Titular de la cuenta` }
    );
  }
  return header;
};

const affiliationsDBPayments = (quotas) => {
  let header = [];

  for (let i = 1; i <= quotas; i++) {
    header.push(
      { name: `Método de Pago ${i}` },
      { name: `Monto Pago ${i} $` },
      { name: `Monto Recibido ${i} BsS` },
      { name: `Referencia de Pago ${i}` },
      { name: `Titular de la cuenta ${i}` },
      { name: `Fecha de pago ${i}` }
    );
  }
  return header;
};

const salesMembershipinitialPayments = (quotas) => {
  let header = [];

  for (let i = 1; i <= quotas; i++) {
    header.push(
      { name: `Pago Cuota 1 ${i} USD` },
      { name: `Pago Cuota 1 ${i} Bs` },
      { name: `Pago Cuota 1 Método ${i}` },
      { name: `Pago Cuota 1 Referencia ${i}` },
      { name: `Pago Cuota 1 Titular de la cuenta ${i}` }
    );
  }
  return header;
};

const paymentChangesSection = (maxChanges) => {
  let header = [];

  for (let i = 1; i <= maxChanges; i++) {
    header.push(
      { name: `Vuelto Venta ${i} USD` },
      { name: `Vuelto Venta ${i} Bs` },
      { name: `Método Vuelto Venta ${i}` },
      { name: `Referencia Vuelto ${i}` }
    );
  }
  return header;
};

export const PAPTableHeader = [
  { name: 'Acción', value: '', sortable: false, hidePrint: true },
  { name: 'Numero de orden', value: 'name', sortable: false },
  { name: 'Monto ingresado $', value: '', sortable: false },
  { name: 'Monto ingresado Bs', value: '', sortable: false },
  { name: 'Canal', value: '', sortable: false },
  { name: 'Fecha de Creacion', value: '', sortable: false },
  { name: 'Nombre', value: '', sortable: false },
  { name: 'Apellido', value: '', sortable: false },
  { name: 'Cédula', value: '', sortable: false },
  { name: 'Teléfono', value: '', sortable: false },
  { name: 'Correo', value: '', sortable: false },
  { name: 'Fecha de Inicio', value: '', sortable: false },
  { name: 'Fecha Fin', value: '', sortable: false },
  { name: 'Estatus', value: '', sortable: false },
  { name: 'Anualidad', value: '', sortable: false },
  { name: 'Cant. Servicios', value: '', sortable: false },
];

export const potentialClientsTableHeader = (
  type,
  channels,
  actions,
  serviceTypes
) => [
  { name: 'Nombre y Apellido', value: '', sortable: false, hidePrint: true },
  ...(type !== 'Particular'
    ? [{ name: 'Cedula', value: '', sortable: false }]
    : []),
  { name: 'Numero', value: '', sortable: false },
  {
    name:
      type === 'Evento'
        ? 'Fecha Evento'
        : type === 'Particular'
          ? 'Fecha Servicio'
          : type === 'Pap'
            ? 'Fecha de registro'
            : type === 'Incompleta'
              ? 'Fecha de intento de afiliación'
              : 'Fecha de Afiliación',
    value: '',
    sortable: false,
  },
  ...(type !== 'Incompleta'
    ? [{ name: 'Ciudad', value: '', sortable: false }]
    : []),
  {
    name: 'Canal',
    value: '',
    sortable: true,
    filterOptions: channels,
    filterSearch: actions.channels,
  },
  ...(type === 'Particular'
    ? [
        {
          name: 'Tipo de servicio',
          value: '',
          sortable: true,
          filterOptions: serviceTypes,
          filterSearch: actions.serviceTypes,
        },
      ]
    : []),
  ...(['Particular', 'Free'].includes(type)
    ? [{ name: 'Placa', value: '', sortable: false }]
    : []),
  {
    name: 'Afiliado',
    value: '',
    sortable: true,
    filterOptions: [
      { name: 'Sí', _id: 'true' },
      { name: 'No', _id: 'false' },
    ],
    filterSearch: actions.affiliated,
  },
  { name: 'Número de orden', value: '', sortable: false },
  { name: 'Fecha de afiliación', value: '', sortable: false },
  { name: 'Estatus de afiliación', value: '', sortable: false },
  { name: 'Canal afiliado', value: '', sortable: false },
  { name: 'Asesor responsable', value: '', sortable: false },
  { name: 'Plan', value: '', sortable: false },
  { name: 'Total facturado', value: '', sortable: false },
  ...(type !== 'Pap'
    ? [
        {
          name: 'Acción de campaña',
          value: '',
          sortable: true,
          filterOptions: campaignContactOptions,
          filterSearch: actions.campaign,
        },
      ]
    : []),
  ...(type !== 'Incompleta'
    ? [
        {
          name: 'Situación',
          value: '',
          sortable: false,
        },
      ]
    : []),
];

export const salesMembershipTableHeader = (paymentsQty) => [
  { name: 'Acción', value: '', sortable: false, hidePrint: true },
  { name: 'Membresia', value: 'name', sortable: false },
  { name: 'Membresias Asociadas', value: '', sortable: false },
  { name: 'Fecha Creación', value: 'name', sortable: false },
  { name: 'Asesor responsable', value: '', sortable: false },
  {
    name: 'Canal',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  { name: 'Evento', value: 'state', sortable: false },
  { name: 'Plan', value: 'state', sortable: false },
  { name: 'Estatus de afiliación', value: '', sortable: false },
  { name: 'Condición Afiliación', value: 'phone', sortable: false },
  { name: 'Plan anterior', value: 'phone', sortable: false },
  { name: 'Mes plan anterior', value: 'phone', sortable: false },
  { name: 'Canal anterior', value: 'phone', sortable: false },
  { name: 'Cliente', value: '', sortable: false },
  { name: 'Cédula', value: '', sortable: false },
  { name: 'Género', value: '', sortable: false },
  { name: 'Teléfono', value: '', sortable: false },
  { name: 'Teléfono Opcional', value: '', sortable: false },
  { name: 'Placa', value: '', sortable: false },
  { name: 'Clase', value: '', sortable: false },
  { name: 'Año Vehículo', value: '', sortable: false },
  { name: 'Código aplicado', value: '', sortable: false },
  { name: 'Modalidad de pago', value: '', sortable: false },
  { name: 'Tipo de pago', value: '', sortable: false },
  { name: 'RCV', value: '', sortable: false },
  { name: 'Perdida', value: '', sortable: false },
  { name: '% de Descuento Renovacion', value: '', sortable: false },
  { name: 'Facturación de planes $', value: '', sortable: false },
  { name: 'Facturación de RCV $', value: '', sortable: false },
  { name: 'Facturación tarjeta RCV', value: '', sortable: false },
  { name: 'Facturación Certificado Médico $', value: '', sortable: false },
  { name: 'Monto Ingresado $', value: '', sortable: false },
  { name: 'Monto Ingresado Bs', value: '', sortable: false },

  ...affiliationsDBPayments(MAX_PAYMENT_METHODS),
  { name: 'Vuelto total Venta', value: '', sortable: false },
  ...paymentChangesSection(MAX_CASHBACK_METHODS),

  ...salesPaymentInitial(MAX_PAYMENT_METHODS),
  { name: 'Vuelto total Venta', value: '', sortable: false },
  ...paymentChangesSection(MAX_CASHBACK_METHODS),
  // Pagos financiados
  { name: 'Fecha de vencimiento Cuota 1', value: '', sortable: false },
  { name: 'Fecha de pago Cuota 1', value: '', sortable: false },
  ...salesMembershipinitialPayments(MAX_PAYMENT_METHODS),
  { name: 'Vuelto total Venta', value: '', sortable: false },
  ...paymentChangesSection(MAX_CASHBACK_METHODS),
  // Cashea
  { name: 'Referencia de Cashea', value: '', sortable: false },
  ...casheaBDAffiliationQuotas(paymentsQty),
  { name: 'Cuenta por cobrar', value: '', sortable: false },
  { name: 'Estatus cuenta por cobrar', value: '', sortable: false },
  { name: 'Ajuste', value: '', sortable: false },
  { name: 'Motivo de ajuste', value: '', sortable: false },
  {
    name: 'Estado',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Ciudad',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  { name: 'Contrato', value: '', sortable: false },
  { name: 'Correo', value: '', sortable: false },
  { name: 'Fecha Nacimiento', value: '', sortable: false },
  {
    name: 'Marca',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Modelo',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  { name: 'Asesor asignado', value: '', sortable: false },
  { name: 'Renovaciones continuas', value: '', sortable: false },
  { name: 'Fecha inicio RCV', value: '', sortable: false },
  { name: 'Fecha fin RCV', value: '', sortable: false },
  { name: 'Fecha inicio plan', value: '', sortable: false },
  { name: 'Fecha fin plan', value: '', sortable: false },
  { name: 'Nivel siniestralidad', value: '', sortable: false },
  { name: 'KM', value: '', sortable: false },
  { name: 'KM Ilimitados', value: '', sortable: false },
  { name: 'Upgrade', value: 'state', sortable: false },
  { name: 'Pago Upgrade $', value: 'state', sortable: false },
  { name: 'Pago Upgrade Bs', value: 'state', sortable: false },
  // { name: 'Titular de la cuenta Upgrade', value: 'state', sortable: false },
  { name: 'Monto Pago 1 RCV', value: 'state', sortable: false },
  { name: 'Monto Pago 1 Bs RCV', value: 'state', sortable: false },
  { name: 'Método Pago 1 RCV', value: 'state', sortable: false },
  { name: 'Referencia Pago 1 RCV', value: 'state', sortable: false },
  { name: 'Titular de la cuenta Pago 1 RCV', value: 'state', sortable: false },
  { name: 'Fecha Pago 1 RCV', value: 'state', sortable: false },
  { name: 'Monto Pago 2 RCV', value: 'state', sortable: false },
  { name: 'Monto Pago 2 Bs RCV', value: 'state', sortable: false },
  { name: 'Método Pago 2 RCV', value: 'state', sortable: false },
  { name: 'Referencia Pago 2 RCV', value: 'state', sortable: false },
  { name: 'Titular de la cuenta Pago 2 RCV', value: 'state', sortable: false },
  { name: 'Fecha Pago 2 RCV', value: 'state', sortable: false },

  { name: 'Empresa', value: '', sortable: false },
  { name: 'Acción de Campaña', value: '', sortable: false },
];

export const casheaTableHeader = [
  { name: 'Nro Orden', value: 'name', sortable: false },
  { name: 'Ref Cashea', value: 'name', sortable: false },
  { name: 'Fecha de Creación', value: '', sortable: false },
  { name: 'Asesor Responsable', value: 'phone', sortable: false },
  { name: 'Canal', value: '', sortable: false },
  { name: 'Plan', value: '', sortable: false },
  { name: 'Cliente', value: '', sortable: false },
  { name: 'Monto Facturado USD', value: '', sortable: false },
  { name: 'Monto Ingresado USD', value: '', sortable: false },
  { name: 'Monto Deuda USD', value: '', sortable: false },
];
export const CasheaPaymentsReportTableHeader = [
  { name: 'Fecha de Creación', value: '', sortable: false },
  { name: 'Descripción', value: 'phone', sortable: false },
  { name: 'Archivo con pagos no procesados', value: '', sortable: false },
];

export const casheaReportsHeader = [
  { name: 'Fecha de Transacción', value: '', sortable: false },
  { name: 'Moneda', value: 'name', sortable: false },
  { name: 'Método de Pago', value: 'name', sortable: false },
  { name: 'Cuenta', value: 'phone', sortable: false },
  { name: 'Monto pagado en VES', value: '', sortable: false },
  { name: 'Monto pagado en USD', value: '', sortable: false },
  { name: 'Fecha Tasa de Cambio', value: '', sortable: false },
  { name: 'Tasa de Cambio', value: '', sortable: false },
  { name: '# Referencia', value: '', sortable: false },
  { name: '# Cuota Pagada', value: '', sortable: false },
  { name: '# Orden', value: '', sortable: false },
  { name: '# Factura', value: '', sortable: false },
  { name: 'Sucursal', value: '', sortable: false },
];

export const RCVsTableHeader = [
  { name: 'Nro Orden', value: 'name', sortable: false },
  { name: 'Tipo de venta', value: 'name', sortable: false },
  { name: 'Prima', value: 'phone', sortable: false },
  { name: 'Fecha inicio RCV', value: '', sortable: false },
  { name: 'Fecha fin RCV', value: '', sortable: false },
  { name: 'Cliente', value: '', sortable: false },
  { name: 'Cédula', value: '', sortable: false },
  { name: 'Teléfono', value: '', sortable: false },
  { name: 'Correo', value: '', sortable: false },
  { name: 'Fecha Nacimiento', value: '', sortable: false },
  { name: 'Estado', value: '', sortable: false },
  { name: 'Ciudad', value: '', sortable: false },
  // { name: 'Dirección', value: '', sortable: false },
  { name: 'Placa', value: '', sortable: false },
  { name: 'Clase', value: '', sortable: false },
  { name: 'Tipo', value: '', sortable: false },
  { name: 'Marca', value: '', sortable: false },
  { name: 'Modelo', value: '', sortable: false },
  { name: 'Color', value: '', sortable: false },
  { name: 'Año Vehículo', value: '', sortable: false },
  { name: 'Serial de Carrocería', value: '', sortable: false },
];

export const RCV_CS_TableHeader = [
  { name: 'Identificador', value: 'name', sortable: false },
  { name: 'Número de Identificación', value: 'name', sortable: false },
  { name: 'Nombre', value: 'name', sortable: false },
  { name: 'Apellido', value: 'name', sortable: false },
  { name: 'Sexo', value: 'name', sortable: false },
  { name: 'Estado Civil', value: 'name', sortable: false },
  { name: 'Fecha de Nacimiento', value: 'name', sortable: false },
  { name: 'Profesión', value: 'name', sortable: false },
  { name: 'Actividad Económica', value: 'name', sortable: false },
  { name: 'Teléfono', value: 'name', sortable: false },
  { name: 'Calle', value: 'name', sortable: false },
  { name: 'Edificio/Casa', value: 'name', sortable: false },
  { name: 'Apto', value: 'name', sortable: false },
  { name: 'Parroquia', value: 'name', sortable: false },
  { name: 'Municipio', value: 'name', sortable: false },
  { name: 'Ciudad', value: 'name', sortable: false },
  { name: 'Estado', value: 'name', sortable: false },
  { name: 'Correo', value: 'name', sortable: false },
  { name: 'Identificador del tomador', value: 'name', sortable: false },
  {
    name: 'Número de Identificación del tomador',
    value: 'name',
    sortable: false,
  },
  { name: 'Nombre del Tomador', value: 'name', sortable: false },
  { name: 'Apellido del Tomador', value: 'name', sortable: false },
  {
    name: 'Identificador del Propietario del vehículo',
    value: 'name',
    sortable: false,
  },
  {
    name: 'Número de Identificación del Propietario del vehículo',
    value: 'name',
    sortable: false,
  },
  { name: 'Nombre Propietario del vehículo', value: 'name', sortable: false },
  { name: 'Apellido Propietario del vehículo', value: 'name', sortable: false },
  { name: 'Marca', value: 'name', sortable: false },
  { name: 'Modelo', value: 'name', sortable: false },
  { name: 'Año', value: 'name', sortable: false },
  { name: 'Placa', value: 'name', sortable: false },
  { name: 'Color', value: 'name', sortable: false },
  { name: 'Serial de Carroceria', value: 'name', sortable: false },
  { name: 'Serial NIV del Vehículo', value: 'name', sortable: false },
  { name: 'Tipo de Vehículo', value: 'name', sortable: false },
  { name: 'Uso del Vehículo', value: 'name', sortable: false },
  { name: 'Número de puestos del vehículo', value: 'name', sortable: false },
  { name: 'Lugar de uso del vehículo', value: 'name', sortable: false },
  { name: 'N° de Licencia', value: 'name', sortable: false },
  { name: 'Colegio del Productor', value: 'name', sortable: false },
  { name: 'Sucursal Oficina', value: 'name', sortable: false },
  { name: 'Moneda', value: 'name', sortable: false },
  { name: 'Póliza', value: 'name', sortable: false },
  { name: 'Fecha de Emisión Póliza', value: 'name', sortable: false },
  { name: 'Desde Póliza', value: 'name', sortable: false },
  { name: 'Hasta Póliza', value: 'name', sortable: false },
  { name: 'Ramo', value: 'name', sortable: false },
  { name: 'Cobertura', value: 'name', sortable: false },
  { name: 'Suma Asegurada', value: 'name', sortable: false },
  { name: 'Prima', value: 'name', sortable: false },
  { name: 'Tipo de RCV', value: 'name', sortable: false },
  { name: 'Comisión', value: 'name', sortable: false },
  { name: 'Deducible', value: 'name', sortable: false },
  { name: 'N° de Recibo', value: 'name', sortable: false },
  { name: 'Tipo de Recibo', value: 'name', sortable: false },
  { name: 'Fecha de Emisión Recibo', value: 'name', sortable: false },
  { name: 'Vigencia desde Recibo', value: 'name', sortable: false },
  { name: 'Vigencia hasta Recibo', value: 'name', sortable: false },
  { name: 'Ingreso', value: 'name', sortable: false },
  { name: 'Descripcion del Ingreso', value: 'name', sortable: false },
  { name: 'Tipo de Ingreso', value: 'name', sortable: false },
  { name: 'Tasa', value: 'name', sortable: false },
  { name: 'Fecha de la tasa', value: 'name', sortable: false },
  { name: 'Estatus', value: 'name', sortable: false },
  { name: 'Motivo de Anulación', value: 'name', sortable: false },
  { name: 'Cédula', value: 'name', sortable: false },
  { name: 'Licencia de conducir', value: 'name', sortable: false },
  // { name: 'Carnet de circulación', value: 'name', sortable: false },
  { name: 'Título de propiedad del vehículo', value: 'name', sortable: false },
  { name: 'Poliza RCV', value: 'name', sortable: false },
  { name: 'Carnet RCV', value: 'name', sortable: false },
  { name: 'Documento de solicitud', value: 'name', sortable: false },
  { name: 'Número del Título de Propiedad', value: 'name', sortable: false },
];

const upgradePaymentsHeader = () => {
  let header = [];

  for (let i = 0; i < MAX_PAYMENT_METHODS; i++) {
    header.push({ name: `Método de Pago ${i + 1}` });
    header.push({ name: `Pago Upgrade $ ${i + 1}` });
    header.push({ name: `Pago Upgrade Bs ${i + 1}` });
    header.push({ name: `Referencia ${i + 1}` });
  }
  return header;
};

export const UpgradesTableHeader = [
  { name: 'Fecha de Upgrade', value: 'name', sortable: false },
  { name: 'Asesor', value: 'name', sortable: false },
  { name: 'Nro, Orden', value: 'name', sortable: false },
  { name: 'Cliente', value: 'name', sortable: false },
  { name: 'Cambio de plan', value: 'name', sortable: false },
  { name: 'Cambio de Km', value: 'name', sortable: false },
  { name: 'Grúa extendido', value: 'name', sortable: false },
  { name: 'Placa', value: 'name', sortable: false },
  { name: 'Cédula', value: 'name', sortable: false },
  ...upgradePaymentsHeader(),
  { name: 'Estado', value: 'name', sortable: false },
  { name: 'Ciudad', value: 'name', sortable: false },
  { name: 'Año', value: 'name', sortable: false },
  { name: 'Blindaje', value: 'name', sortable: false },
];
export const CxCTableHeader = [
  { name: 'Nro, Orden', value: 'name', sortable: false },
  { name: 'Asesor', value: 'name', sortable: false },
  { name: 'Fecha de afiliacion', value: 'name', sortable: false },
  { name: 'Cliente', value: 'name', sortable: false },
  { name: 'Plan', value: 'name', sortable: false },
  { name: 'Canal', value: 'name', sortable: false },
  { name: 'Tipo de Venta', value: 'name', sortable: false },
  { name: 'Modalidad de pago', value: 'name', sortable: false },
  { name: 'Cuenta por cobrar', value: 'name', sortable: false },
  { name: 'Fecha de vencimiento', value: 'name', sortable: false },
];

export const PAPComissionTableHeader = [
  { name: 'Acciones', value: 'name', sortable: false },
  { name: 'Mes', value: 'name', sortable: false },
  { name: 'Canal', value: 'name', sortable: false },
  { name: 'Cantidad de PAP Mensuales', value: 'name', sortable: false },
  { name: 'Cantidad de PAP Anuales', value: 'name', sortable: false },
  { name: 'Monto Total Cobrado', value: 'name', sortable: false },
  { name: 'Monto Total Cobrado Bs', value: 'name', sortable: false },
  { name: 'Comision PAP', value: 'name', sortable: false },
  { name: 'Comision PAP Bs', value: 'name', sortable: false },
  { name: 'Monto a Cobrar', value: 'name', sortable: false },
  { name: 'Monto a Cobrar Bs', value: 'name', sortable: false },
];

export const AffiliationComissions = [
  { name: 'Acciones', value: 'name', sortable: false },
  { name: 'Mes', value: 'name', sortable: false },
  { name: 'Canal', value: 'name', sortable: false },
  { name: 'Cantidad Afiliaciones', value: 'name', sortable: false },
  { name: 'Monto Total Facturado', value: 'name', sortable: false },
  { name: 'Monto Comision a Pagar', value: 'name', sortable: false },
];

export const AffiliationComissionsDetail = [
  { name: 'Nro. Orden', value: 'name', sortable: false },
  { name: 'Canal', value: 'name', sortable: false },
  { name: 'Fecha de Creacion', value: 'name', sortable: false },
  { name: 'Nombre', value: 'name', sortable: false },
  { name: 'Apellido', value: 'name', sortable: false },
  { name: 'Cedula', value: 'name', sortable: false },
  { name: 'Nro. Orden PAP', value: 'name', sortable: false },
];

const salesPaymentMethod = (methods) => {
  let header = [];

  for (let i = 1; i <= methods; i++) {
    header.push(
      { name: `Método de Pago ${i}` },
      { name: `Monto Pago ${i} $` },
      { name: `Monto Pago ${i} BsS` },
      { name: `Referencia de Pago ${i}` },
      { name: `Titular de la cuenta ${i}` },
      { name: `Fecha de pago ${i}` }
    );
  }
  return header;
};

const salesFirstQuota = (methods) => {
  let header = [];

  for (let i = 1; i <= methods; i++) {
    header.push(
      { name: `Cuota 1 Monto pagado ${i} USD` },
      { name: `Cuota 1 Monto pagado ${i} Bs` },
      { name: `Cuota 1 Método ${i}` },
      { name: `Cuota 1 Referencia ${i}` },
      { name: `Cuota 1 Titular de la cuenta ${i}` }
    );
  }
  return header;
};

const pendingQuotas = (methods) => {
  let header = [];

  for (let i = 2; i <= methods; i++) {
    header.push(
      { name: `Fecha vencimiento cuota ${i}` },
      { name: `Fecha de pago Cuota ${i}` },
      { name: `Cuota ${i} Monto USD` },
      { name: `Cuota ${i} Monto pagado Bs` },
      { name: `Cuota ${i} Método` },
      { name: `Cuota ${i} Referencia` },
      { name: `Cuota ${i} Titular de la cuenta` }
    );
  }
  return header;
};

export const exportablesSalesTable = (methods) => [
  { name: 'Nro Orden', value: 'name', sortable: false },
  { name: 'Fecha creación', value: 'name', sortable: false },
  { name: 'Ordenes asociadas', value: 'name', sortable: false },
  { name: 'Asesor responsable', value: 'phone', sortable: false },
  { name: 'Canal', value: '', sortable: false },
  { name: 'Evento', value: '', sortable: false },
  { name: 'Plan', value: '', sortable: false },
  { name: 'Tipo de venta', value: '', sortable: false },
  { name: 'Plan Anterior', value: '', sortable: false },
  { name: 'Fecha fin plan anterior', value: '', sortasble: false },
  { name: 'Cliente', value: '', sortable: false },
  { name: 'Placa', value: '', sortable: false },
  { name: 'Año Vehículo', value: '', sortable: false },
  { name: 'Código aplicado', value: '', sortable: false },
  { name: 'Modalidad de pago', value: '', sortable: false },
  { name: 'Tipo de pago', value: '', sortable: false },
  { name: 'RCV', value: '', sortable: false },
  { name: 'Perdida', value: '', sortable: false },
  { name: '% Descuento Renovación', value: '', sortable: false },
  { name: 'Facturacion de Planes', value: '', sortable: false },
  { name: 'Facturacion de RCVs', value: '', sortable: false },
  { name: 'Tarjeta RCV', value: '', sortable: false },
  { name: 'Facturación Certificado Médico', value: '', sortable: false },

  // { name: 'Monto Factura $', value: '', sortable: false },
  // { name: 'Monto Factura BsS', value: '', sortable: false },
  // Payment section

  ...salesPaymentMethod(MAX_PAYMENT_METHODS),
  { name: 'Vuelto total Venta', value: '', sortable: false },
  ...paymentChangesSection(MAX_CASHBACK_METHODS),
  // Pagos financiados
  { name: 'Pago Inicial Fecha de pago', value: '', sortable: false },
  ...salesPaymentInitial(MAX_PAYMENT_METHODS),
  { name: 'Vuelto total Venta', value: '', sortable: false },
  ...paymentChangesSection(MAX_CASHBACK_METHODS),
  { name: 'Fecha de vencimiento Cuota 1', value: '', sortable: false },
  { name: 'Fecha de pago Cuota 1', value: '', sortable: false },
  ...salesFirstQuota(MAX_PAYMENT_METHODS),
  { name: 'Vuelto total Venta', value: '', sortable: false },
  ...paymentChangesSection(MAX_CASHBACK_METHODS),
  { name: 'Referencia de Cashea', value: '', sortable: false },
  ...casheaBDAffiliationQuotas(methods),
  { name: 'Cuenta por cobrar', value: '', sortable: false },
  { name: 'Estatus cuenta por cobrar', value: '', sortable: false },

  // Rest
  { name: 'Estado', value: '', sortable: false },
  { name: 'Ciudad', value: '', sortable: false },
  { name: 'Modelo', value: '', sortable: false },
  { name: 'Fecha inicio plan', value: '', sortable: false },
  { name: 'Fecha fin plan', value: '', sortable: false },
  { name: 'KM', value: '', sortable: false },
  { name: 'KM Ilimitados', value: '', sortable: false },
  { name: 'Fecha inicio RCV', value: '', sortable: false },
  { name: 'Fecha fin RCV', value: '', sortable: false },
  { name: 'Condición afiliación', value: '', sortable: false },
  { name: 'Monto Pago 1 RCV', value: 'state', sortable: false },
  { name: 'Monto Pago 1 Bs RCV', value: 'state', sortable: false },
  { name: 'Método Pago 1 RCV', value: 'state', sortable: false },
  { name: 'Referencia Pago 1 RCV', value: 'state', sortable: false },
  { name: 'Fecha Pago 1 RCV', value: 'state', sortable: false },
  { name: 'Monto Pago 2 RCV', value: 'state', sortable: false },
  { name: 'Monto Pago 2 Bs RCV', value: 'state', sortable: false },
  { name: 'Método Pago 2 RCV', value: 'state', sortable: false },
  { name: 'Referencia Pago 2 RCV', value: 'state', sortable: false },
  { name: 'Fecha Pago 2 RCV', value: 'state', sortable: false },
];

export const exportablesAdminTable = [
  { name: 'Nro. orden', value: '', sortable: false },
  { name: 'Ordenes Asociadas', value: 'name', sortable: false },
  {
    name: 'Fecha de carga',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Fecha de pago',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  { name: 'Modalidad de pago', value: '', sortable: false },
  { name: 'Tipo de pago', value: '', sortable: false },
  { name: 'Cuota pagada', value: '', sortable: false },
  { name: 'Total facturación', value: '', sortable: false },
  { name: 'Facturación de planes $', value: '', sortable: false },
  { name: 'Facturación de RCV $', value: '', sortable: false },
  { name: 'Facturación tarjeta RCV', value: '', sortable: false },
  { name: 'Facturación Certificado Médico $', value: '', sortable: false },
  { name: 'Pago upgrade $', value: '', sortable: false },
  { name: 'Monto ingresado $', value: '', sortable: false },
  { name: 'Monto ingresado Bs', value: '', sortable: false },
  { name: 'Método de pago', value: '', sortable: false },
  { name: 'Referencia', value: '', sortable: false },
  { name: 'Lote de transacción', value: '', sortable: false },
  { name: 'Titular de la cuenta', value: '', sortable: false },
  { name: 'Observación', value: '', sortable: false },
  { name: 'Caja de venta', value: '', sortable: false },
  { name: 'Mismo pago', value: '', sortable: false },
  { name: 'Cuenta por cobrar', value: '', sortable: false },
  { name: 'Ajuste', value: '', sortable: false },
  { name: 'Motivo de ajuste', value: '', sortable: false },
  { name: 'Referencia Cashea', value: '', sortable: false },
  { name: 'Fecha Creación', value: '', sortable: false },
  { name: 'Vuelto total Venta', value: '', sortable: false },
  { name: 'Vuelto Venta 1 USD', value: '', sortable: false },
  { name: 'Vuelto Venta 1 Bs', value: '', sortable: false },
  { name: 'Método Vuelto Venta 1', value: '', sortable: false },
  { name: 'Referencia Vuelto Venta 1', value: '', sortable: false },
  { name: 'Observación Vuelto Venta 1', value: '', sortable: false },
  { name: 'Vuelto Venta 2 USD', value: '', sortable: false },
  { name: 'Vuelto Venta 2 Bs', value: '', sortable: false },
  { name: 'Método Vuelto Venta 2', value: '', sortable: false },
  { name: 'Referencia Vuelto Venta 2', value: '', sortable: false },
  { name: 'Observación Vuelto Venta 2', value: '', sortable: false },
  { name: 'Vuelto Venta 3 USD', value: '', sortable: false },
  { name: 'Vuelto Venta 3 Bs', value: '', sortable: false },
  { name: 'Método Vuelto Venta 3', value: '', sortable: false },
  { name: 'Referencia Vuelto Venta 3', value: '', sortable: false },
  { name: 'Observación Vuelto Venta 3', value: '', sortable: false },
  { name: 'Canal', value: '', sortable: false },
  { name: 'Plan', value: 'state', sortable: false },
  { name: 'Tipo de Venta', value: 'state', sortable: false },
  { name: 'Código aplicado', value: 'state', sortable: false },
  { name: 'Factura', value: 'state', sortable: false },
  { name: 'Número de factura', value: 'state', sortable: false },
  { name: 'Pago validado', value: 'state', sortable: false },
];

export const exportablesRCVCorpTable = [
  // DATOS DEL TOMADOR
  { name: 'Tipo Tomador', value: '', sortable: false },
  { name: 'ID Tomador', value: '', sortable: false },
  { name: 'Nombres Tomador', value: '', sortable: false },
  { name: 'Apellidos Tomador', value: '', sortable: false },
  { name: 'Sexo Tomador', value: '', sortable: false },
  { name: 'Estado Civil Tomador', value: '', sortable: false },
  { name: 'Fecha Nacimiento Tomador', value: '', sortable: false },
  { name: 'Telefonos Tomador', value: '', sortable: false },
  { name: 'Direccion Tomador', value: '', sortable: false },
  { name: 'Codigo Estado Tomador', value: '', sortable: false },
  { name: 'Ciudad Tomador', value: '', sortable: false },
  { name: 'Email Tomador', value: '', sortable: false },
  // DATOS DEL Titular
  { name: 'Tipo Cliente', value: '', sortable: false },
  { name: 'ID Cliente', value: '', sortable: false },
  { name: 'Nombres Cliente', value: '', sortable: false },
  { name: 'Apellidos Cliente', value: '', sortable: false },
  { name: 'Sexo Cliente', value: '', sortable: false },
  { name: 'Estado Civil Cliente', value: '', sortable: false },
  { name: 'Fecha Nacimiento Cliente', value: '', sortable: false },
  { name: 'Telefonos Cliente', value: '', sortable: false },
  { name: 'Direccion Cliente', value: '', sortable: false },
  { name: 'Codigo Estado Cliente', value: '', sortable: false },
  { name: 'Ciudad Cliente', value: '', sortable: false },
  { name: 'Email Cliente', value: '', sortable: false },
  // DATOS DEL TITULAR DE LA POLIZA
  { name: 'Cod Marca', value: '', sortable: false },
  { name: 'Desc Marca', value: '', sortable: false },
  { name: 'Cod Modelo', value: '', sortable: false },
  { name: 'Desc Modelo', value: '', sortable: false },
  { name: 'Cod Version', value: '', sortable: false },
  { name: 'Desc Version', value: '', sortable: false },
  { name: 'Tipolval', value: '', sortable: false },
  { name: 'Cod Lval', value: '', sortable: false },
  { name: 'Descrip', value: '', sortable: false },
  { name: 'Tipolval 2', value: '', sortable: false },
  { name: 'Cod Lval 2', value: '', sortable: false },
  { name: 'Descrip 2', value: '', sortable: false },
  { name: 'Cod Lval 3', value: '', sortable: false },
  { name: 'Descrip 3', value: '', sortable: false },
  { name: 'Placa Vehiculo', value: '', sortable: false },
  { name: 'Color', value: '', sortable: false },
  { name: 'Serial Carroceria', value: '', sortable: false },
  { name: 'Serial Motor', value: '', sortable: false },
  { name: 'Puestos', value: '', sortable: false },
  { name: 'Fecha de Adquisicion', value: '', sortable: false },
  // DATOS DE POLIZA
  { name: 'Oficina', value: '', sortable: false },
  { name: 'Codigo Moneda', value: '', sortable: false },
  { name: 'Numero Poliza', value: '', sortable: false },
  { name: 'Fecha Emision', value: '', sortable: false },
  { name: 'Fecha Inicio', value: '', sortable: false },
  { name: 'Fecha Vencimiento', value: '', sortable: false },
  { name: 'Ramo', value: '', sortable: false },
  { name: 'Suma Asegurada Danos a Personas', value: '', sortable: false },
  { name: 'Suma Asegurada Danos a Cosas', value: '', sortable: false },
  { name: 'Prima', value: '', sortable: false },

  { name: 'Suma Asegurada Exceso de Limite', value: '', sortable: false },
  { name: 'Prima 2', value: '', sortable: false },
  { name: 'Suma Asegurada Muerte Accidental', value: '', sortable: false },
  { name: 'Prima 3', value: '', sortable: false },
  {
    name: 'Cobertura Invalidez Total y Permanente',
    value: '',
    sortable: false,
  },
  { name: 'Prima 4', value: '', sortable: false },

  { name: 'Prima Total', value: '', sortable: false },
  { name: 'Tasa Moneda', value: '', sortable: false },
  { name: 'Comision', value: '', sortable: false },

  // DATOS DEL RECIBO
  { name: 'Numero Recibo', value: '', sortable: false },
  { name: 'Fecha Emision Recibo', value: '', sortable: false },
  { name: 'Fecha Inicio Recibo', value: '', sortable: false },
  { name: 'Fecha Vencimiento Recibo', value: '', sortable: false },

  //Documentos
  { name: 'Cédula', value: '', sortable: false },
  { name: 'Licencia de Conducir', value: '', sortable: false },
  { name: 'Título de Propiedad del Vehículo', value: '', sortable: false },
  { name: 'Poliza RCV', value: '', sortable: false },
  { name: 'Carnet RCV', value: '', sortable: false },
];

export const exportablesPendingAccounts = [
  { name: 'Nro Orden', value: 'name', sortable: false },
  { name: 'Cliente', value: '', sortable: false },
  { name: 'Plan', value: '', sortable: false },
  { name: 'Canal', value: '', sortable: false },
  { name: 'Tipo de venta', value: '', sortable: false },
  { name: 'Fecha de Afiliacion', value: '', sortable: false },
  { name: 'Modalidad de Pago', value: '', sortable: false },
  { name: 'Fecha de vencimiento de la cuota', value: '', sortable: false },
  { name: 'Monto pagado $', value: '', sortable: false },
  { name: 'Monto pagado Bs', value: '', sortable: false },
  { name: 'Fecha de pago', value: '', sortable: false },
  { name: 'Mes de pago', value: '', sortable: false },
  { name: 'Monto de Pago 1 $', value: '', sortable: false },
  { name: 'Monto de Pago 1 Bs', value: '', sortable: false },
  { name: 'Método de Pago 1', value: '', sortable: false },
  { name: 'Referencia de Pago 1', value: '', sortable: false },
  { name: 'Monto de Pago 2 $', value: '', sortable: false },
  { name: 'Monto de Pago 2 Bs', value: '', sortable: false },
  { name: 'Método de Pago 2', value: '', sortable: false },
  { name: 'Referencia de Pago 2', value: '', sortable: false },
];

export const pendingForApprovalTableHeader = [
  {
    name: 'Acción',
    value: '',
    sortable: false,
    hidePrint: true,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Membresia',
    value: 'name',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Tipo de Afiliación',
    value: 'name',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Asesor',
    value: 'name',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Canal',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Cliente',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Cédula',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Placa',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Teléfono',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Documentos comprobados',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Plan',
    value: 'state',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Pago comprobado',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Tipo de pago',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Monto factura $',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Comentario',
    value: 'name',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Fecha Creación',
    value: 'name',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
];

export const lostTableHeader = [
  { name: 'Acción', value: '', sortable: false, hidePrint: true },
  { name: 'Membresia', value: 'name', sortable: false },
  { name: 'Tipo de Afiliación', value: 'name', sortable: false },
  { name: 'Asesor Asignado', value: 'phone', sortable: false },
  { name: 'Canal', value: '', sortable: false },
  { name: 'Empresa', value: '', sortable: false },
  { name: 'Cliente', value: '', sortable: false },
  { name: 'Cédula', value: '', sortable: false },
  { name: 'Género', value: '', sortable: false },
  { name: 'Placa', value: '', sortable: false },
  { name: 'Teléfono', value: '', sortable: false },
  { name: 'Correo', value: '', sortable: false },
  { name: 'Plan', value: 'state', sortable: false },
  { name: 'Año Vehículo', value: '', sortable: false },
  { name: 'Nivel de Siniestralidad', value: '', sortable: false },
  { name: 'Monto a pagar $', value: '', sortable: false },
  { name: 'Fecha Fin de plan', value: 'name', sortable: false },
  { name: 'Fecha Fin RCV', value: 'name', sortable: false },
  { name: 'Acción de Campaña', value: '', sortable: false },
];

export const fleetLoadDEtailTableHeader = [
  { name: 'Orden Nº', value: 'name', sortable: false },
  { name: 'Estatus afiliación', value: 'name', sortable: false },
  { name: 'Fecha de creación', value: 'state', sortable: false },
  { name: 'Nombre', value: '', sortable: false },
  { name: 'Apellido', value: '', sortable: false },
  { name: 'Identificación', value: '', sortable: false },
  { name: 'Teléfono', value: '', sortable: false },
  { name: 'Correo', value: '', sortable: false },
  { name: 'Estado ', value: '', sortable: false },
  { name: 'Plan', value: '', sortable: false },
  { name: 'Marca', value: '', sortable: false },
  { name: 'Modelo', value: '', sortable: false },
  { name: 'Año', value: '', sortable: false },
  { name: 'Color', value: '', sortable: false },
  { name: 'Placa', value: '', sortable: false },
  { name: 'Fecha inicio plan', value: '', sortable: false },
  { name: 'Fecha fin plan', value: '', sortable: false },
  { name: 'Tipo de venta', value: '', sortable: false },
  { name: 'RCV', value: '', sortable: false },
  { name: 'Fecha inicio RCV', value: '', sortable: false },
  { name: 'Fecha fin RCV', value: '', sortable: false },
  { name: 'KM', value: '', sortable: false },
  { name: 'Servicio de KM ilimitado', value: '', sortable: false },
  { name: 'Acción', value: '', sortable: false },
];

export const renewalTableHeader = [
  {
    name: 'Acción',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Nro. Orden',
    value: 'name',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Asesor Asignado',
    value: 'name',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Acción de Campaña',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Situación',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Plan',
    value: 'state',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Clase vehículo',
    value: 'state',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Año vehículo',
    value: 'state',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Nivel siniestralidad',
    value: 'state',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Cantidad de Servicios de grúa',
    value: 'state',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: '% recarga/descuento',
    value: 'state',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Resumen',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Precio Renovación',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Cliente',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Placa',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Marca',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Modelo',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Cédula',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Teléfono',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Teléfono Opcional',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Correo',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Canal',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  // { name: 'Contrato', value: '', sortable: false, filterOptions: [], filterSearch: () => {}  },
  {
    name: 'Fecha fin plan',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Mes finalización plan',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Tipo de venta',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Fecha fin RCV',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
  {
    name: 'Observación',
    value: '',
    sortable: false,
    filterOptions: [],
    filterSearch: () => {},
  },
];

export const comissionsTableHeader = [
  { name: 'Mes', color: '#f8b289', value: 'name', sortable: false },
  {
    name: 'Meta individual',
    color: '#f8b289',
    value: 'phone',
    sortable: false,
  },
  { name: 'Meta Grupal', color: '#f8b289', value: 'state', sortable: false },
  { name: 'Ventas concretadas', value: 'state', sortable: false },
  { name: '% Comisión Meta Individual Extra', value: 'state', sortable: false },
  { name: '% Comisión Logro Continuo', value: 'state', sortable: false },
  { name: 'Ventas Grupales', value: 'state', sortable: false },
  { name: '% Comisión Meta Grupal', value: 'state', sortable: false },
  { name: 'Ventas RCV', value: 'state', sortable: false },
  { name: 'Planes (USD)', value: 'state', sortable: false },
  { name: 'Monto Base (USD)', value: 'state', sortable: false },
  { name: '% Comisión', value: 'state', sortable: false },
  {
    name: 'Monto a pagar por comisiones del mes (USD)',
    value: 'state',
    sortable: false,
  },
  {
    name: 'Monto cobro CxC meses anteriores',
    value: 'state',
    sortable: false,
  },
  {
    name: 'Monto Base (USD) CxC meses anteriores',
    value: 'state',
    sortable: false,
  },
  {
    name: 'Monto a pagar por comisiones CxC meses anteriores (USD)',
    value: 'state',
    sortable: false,
  },
  { name: 'Tarjetas canjeadas', value: 'state', sortable: false },
  { name: 'Monto Upgrades (USD)', value: 'state', sortable: false },
  { name: 'Monto Base Upgrades (USD)', value: 'state', sortable: false },
  { name: 'Monto a pagar por Upgrades', value: 'state', sortable: false },

  {
    name: 'Monto a pagar por Tarjetas canjeadas',
    value: 'state',
    sortable: false,
  },
  {
    name: 'Monto a pagar por RCV vendido',
    value: 'state',
    sortable: false,
  },

  {
    name: 'Monto a Total pagar por comisiones (USD)',
    value: 'state',
    sortable: false,
  },
  { name: '', value: 'state', sortable: false },
];

const intermediaryComissionHeaderColor = '#f8b289';

export const intermediaryComissionSummaryHeader = [
  {
    name: 'Intermediario',
    color: intermediaryComissionHeaderColor,
    sortable: false,
  },
  {
    name: 'Total Ventas',
    color: intermediaryComissionHeaderColor,
    sortable: false,
  },
  {
    name: 'Total Plan (USD)',
    color: intermediaryComissionHeaderColor,
    sortable: false,
  },
  {
    name: 'Total RCV',
    color: intermediaryComissionHeaderColor,
    sortable: false,
  },
  {
    name: 'Total Neto',
    color: intermediaryComissionHeaderColor,
    sortable: false,
  },
  {
    name: 'Comisión Bs.',
    color: intermediaryComissionHeaderColor,
    sortable: false,
  },
  {
    name: 'Comisión $',
    color: intermediaryComissionHeaderColor,
    sortable: false,
  },
  {
    name: 'Acciones',
    color: intermediaryComissionHeaderColor,
    sortable: false,
  },
];

export const intermediaryComissionDetailHeader = [
  {
    name: 'Membresía',
    color: intermediaryComissionHeaderColor,
    sortable: false,
  },
  {
    name: 'Intermediario',
    color: intermediaryComissionHeaderColor,
    sortable: false,
  },
  { name: 'Fecha', color: intermediaryComissionHeaderColor, sortable: false },
  { name: 'Plan', color: intermediaryComissionHeaderColor, sortable: false },
  {
    name: 'Tipo de Venta',
    color: intermediaryComissionHeaderColor,
    sortable: false,
  },
  { name: 'Cliente', color: intermediaryComissionHeaderColor, sortable: false },
  {
    name: 'Monto Plan',
    color: intermediaryComissionHeaderColor,
    sortable: false,
  },
  {
    name: 'Monto RCV',
    color: intermediaryComissionHeaderColor,
    sortable: false,
  },
  {
    name: 'Total Neto',
    color: intermediaryComissionHeaderColor,
    sortable: false,
  },
  { name: '%', color: intermediaryComissionHeaderColor, sortable: false },
  {
    name: 'Comisión',
    color: intermediaryComissionHeaderColor,
    sortable: false,
  },
  { name: 'Moneda', color: intermediaryComissionHeaderColor, sortable: false },
];

export const goalsTableHeader = [
  { name: 'Año', value: 'name', sortable: false },
  { name: 'Mes', value: 'name', sortable: false },
  { name: 'Meta Grupal', value: 'state', sortable: false },
  {
    name: 'Meta individual',
    value: 'phone',
    sortable: false,
  },
];

export const fleetsRegisterTableHeader = [
  { name: 'ID', value: 'name', sortable: false },
  { name: 'Nombre', value: 'name', sortable: false },
  { name: 'Código', value: 'phone', sortable: false },
  { name: 'Status', value: 'state', sortable: false },
  { name: 'Cargas', value: 'state', sortable: false },
  { name: 'Creado', value: 'state', sortable: false },
  { name: 'Modificado', value: 'state', sortable: false },
  { name: 'Acción', value: '', sortable: false },
];

export const discountTableHeade = (options = {}, actions = {}) => [
  { name: 'Fecha de creación', value: 'name', sortable: false },
  {
    name: 'Código de descuento',
    value: 'name',
    sortable: true,
    filterSearch: actions.codeAction,
  },
  {
    name: 'Descuento',
    value: 'phone',
    sortable: true,
    filterSearch: actions.discountNumberAction,
  },
  { name: 'Renovación', value: 'phone', sortable: false },
  { name: 'Nuevas Membresias', value: 'phone', sortable: false },
  { name: 'RCVs', value: 'phone', sortable: false },
  { name: 'Planes', value: 'phone', sortable: false },
  { name: 'Fecha de inicio', value: 'state', sortable: false },
  { name: 'Fecha de fin', value: 'state', sortable: false },
  {
    name: 'Canal',
    value: 'state',
    sortable: true,
    filterOptions: options.channels,
    filterSearch: actions.channelAction,
  },
  { name: 'Campaña', value: 'state', sortable: false },
  {
    name: 'Status',
    value: '',
    sortable: true,
    filterOptions: options.status,
    filterSearch: actions.statusAction,
  },
  { name: 'Máximo de usos', value: '', sortable: false },
  { name: 'Veces utilizado', value: '', sortable: false },
  { name: 'Acción', value: '', sortable: false },
];

export const giftcardSalesheader = [
  { name: 'Fecha de Venta', value: 'name', sortable: false },
  { name: 'Plan', value: 'phone', sortable: false },
  { name: 'Canal', value: 'phone', sortable: false },
  { name: 'Precio Plan', value: 'phone', sortable: false },
  { name: 'Cantidad Giftcards', value: 'phone', sortable: false },
  { name: 'Total Ventas', value: 'phone', sortable: false },
  { name: 'Creado', value: 'phone', sortable: false },
  { name: 'Modificado', value: 'phone', sortable: false },
  { name: 'Acciones', value: 'phone', sortable: false },
];

export const giftcardSalesCodeheader = [
  { name: 'Código Público', value: 'name', sortable: false },
  { name: 'Código Privado', value: 'phone', sortable: false },
  { name: 'Plan', value: 'phone', sortable: false },
  { name: 'RCV', value: 'phone', sortable: false },
  { name: 'Canal', value: 'phone', sortable: false },
  { name: 'Status', value: 'phone', sortable: false },
  { name: 'Acciones', value: 'phone', sortable: false },
];

export const giftcardParticularSalesheader = (options, actions) => [
  { name: 'Acciones', value: 'phone', sortable: false },
  { name: 'Fecha de Venta', value: 'name', sortable: false },
  {
    name: 'Plan',
    value: 'phone',
    sortable: true,
    filterOptions: options.plans,
    filterSearch: actions.planAction,
  },
  {
    name: 'Canal',
    value: 'phone',
    sortable: true,
    filterOptions: options.channels,
    filterSearch: actions.channelAction,
  },
  { name: 'Cantidad de GC Vendidas', value: 'phone', sortable: false },
  { name: 'Precio Plan', value: 'phone', sortable: false },
  { name: 'Descuento Aplicado', value: 'phone', sortable: false },

  {
    name: 'Código Público',
    value: 'phone',
    sortable: true,
    filterOptions: options.codes,
    filterSearch: actions.codeAction,
  },
  { name: 'Tipo de Venta', value: 'phone', sortable: false },
  { name: 'Nombre y Apellido', value: 'phone', sortable: false },
  { name: 'Teléfono', value: 'phone', sortable: false },
  { name: 'Correo', value: 'phone', sortable: false },
  {
    name: 'Asesor',
    value: 'phone',
    sortable: true,
    filterOptions: options.sellers,
    filterSearch: actions.sellerAction,
  },

  { name: 'Monto pago 1 $', value: 'phone', sortable: false },
  { name: 'Monto pago 1 Bs', value: 'phone', sortable: false },
  { name: 'Método pago 1', value: 'phone', sortable: false },
  { name: 'Referencia pago 1', value: 'phone', sortable: false },
  { name: 'Caja de Venta 1', value: 'phone', sortable: false },
  { name: 'Comprobante pago 1', value: 'phone', sortable: false },
  { name: 'Pago Comprobado 1', value: 'phone', sortable: false },
  { name: 'Monto pago 2 $', value: 'phone', sortable: false },
  { name: 'Monto pago 2 Bs', value: 'phone', sortable: false },
  { name: 'Método pago 2', value: 'phone', sortable: false },
  { name: 'Referencia pago 2', value: 'phone', sortable: false },
  { name: 'Caja de venta 2', value: 'phone', sortable: false },
  { name: 'Comprobante pago 2', value: 'phone', sortable: false },
  { name: 'Pago Comprobado 2', value: 'phone', sortable: false },

  { name: 'Monto pago 3 $', value: 'phone', sortable: false },
  { name: 'Monto pago 3 Bs', value: 'phone', sortable: false },
  { name: 'Método pago 3', value: 'phone', sortable: false },
  { name: 'Referencia pago 3', value: 'phone', sortable: false },
  { name: 'Caja de Venta 3', value: 'phone', sortable: false },
  { name: 'Comprobante pago 3', value: 'phone', sortable: false },
  { name: 'Pago Comprobado 3', value: 'phone', sortable: false },
  { name: 'Monto pago 4 $', value: 'phone', sortable: false },
  { name: 'Monto pago 4 Bs', value: 'phone', sortable: false },
  { name: 'Método pago 4', value: 'phone', sortable: false },
  { name: 'Referencia pago 4', value: 'phone', sortable: false },
  { name: 'Caja de Venta 4', value: 'phone', sortable: false },
  { name: 'Comprobante pago 4', value: 'phone', sortable: false },
  { name: 'Pago Comprobado 4', value: 'phone', sortable: false },

  { name: 'Clase de Vehículo', value: 'phone', sortable: false },
  { name: 'Año de Vehiculo', value: 'phone', sortable: false },
  { name: 'Blindaje', value: 'phone', sortable: false },
  { name: 'Km plan Gold', value: 'phone', sortable: false },
  { name: 'Km Ilimitado', value: 'phone', sortable: false },
  { name: 'Tipo de RCV', value: 'phone', sortable: false },
  { name: 'Uso de Vehiculo', value: 'phone', sortable: false },
  { name: 'Vuelto total Venta', value: 'phone', sortable: false },
  { name: 'Vuelto 1 USD', value: 'phone', sortable: false },
  { name: 'Vuelto 1 Bs', value: 'phone', sortable: false },
  { name: 'Método vuelto 1', value: 'phone', sortable: false },
  { name: 'Referencia vuelto 1', value: 'phone', sortable: false },
  { name: 'Comprobante vuelto 1', value: 'phone', sortable: false },
  { name: 'Vuelto 2 USD', value: 'phone', sortable: false },
  { name: 'Vuelto 2 Bs', value: 'phone', sortable: false },
  { name: 'Método vuelto 2', value: 'phone', sortable: false },
  { name: 'Referencia vuelto 2', value: 'phone', sortable: false },
  { name: 'Comprobante vuelto 2', value: 'phone', sortable: false },
  { name: 'Vuelto 3 USD', value: 'phone', sortable: false },
  { name: 'Vuelto 3 Bs', value: 'phone', sortable: false },
  { name: 'Método vuelto 3', value: 'phone', sortable: false },
  { name: 'Referencia vuelto 3', value: 'phone', sortable: false },
  { name: 'Comprobante vuelto 3', value: 'phone', sortable: false },
];

export const giftcardTableheader = [
  { name: 'Código Público', value: 'name', sortable: false },
  { name: 'Código Privado', value: 'name', sortable: false },
  { name: 'Plan', value: 'phone', sortable: false },
  { name: 'Canal', value: 'phone', sortable: false },
  { name: 'Status', value: 'phone', sortable: false },
  { name: 'Acciones', value: 'phone', sortable: false },
];

export const fleetDetailTableHeader = [
  { name: 'Código de Carga', value: 'name', sortable: false },
  { name: 'Tipo de flota', value: 'name', sortable: false },
  { name: 'Monto de la flota USD', value: 'phone', sortable: false },
  { name: 'Tipo de pago', value: 'state', sortable: false },
  { name: 'Fecha inicio', value: 'state', sortable: false },
  { name: 'Fecha fin', value: 'state', sortable: false },
  { name: 'Cantidad de vehículos', value: '', sortable: false },
  { name: 'Link afiliación', value: '', sortable: false },
  { name: 'Status', value: '', sortable: false },
  { name: 'Detalle', value: '', sortable: false },
  { name: 'Acción', value: '', sortable: false },
];

export const vehiclesMembershipTableHeader = [
  { name: 'Accion', value: 'name', sortable: false },
  { name: 'Canal', value: 'name', sortable: false },
  { name: 'N° Afiliacion', value: 'name', sortable: false },
  { name: 'Plan', value: 'name', sortable: false },
  { name: 'Estatus de Afiliación', value: 'name', sortable: false },
  // { name: 'Cantida de servicios AV', value: 'name', sortable: false },
  { name: 'Cantida de servicios grúa', value: 'name', sortable: false },
  { name: 'Nivel de Siniestralidad', value: 'name', sortable: false },
  { name: 'Tipo de Venta', value: 'name', sortable: false },
  { name: 'Asesor Responsable', value: 'name', sortable: false },
  // { name: 'Fecha de Inicio plan', value: 'name', sortable: false },
  { name: 'Fecha fin RCV', value: 'name', sortable: false },
  { name: 'Fecha de Fin plan', value: 'name', sortable: false },
  { name: 'RCV', value: 'name', sortable: false },
  { name: 'Ver Servicios', value: 'name', sortable: false },
];

export const PAPOldMembershipsTable = [
  { name: 'Accion', value: 'name', sortable: false },
  { name: 'Nro. Orden', value: 'name', sortable: false },
  { name: 'Canal', value: 'name', sortable: false },
  { name: 'Fecha de Creacion', value: 'name', sortable: false },
  { name: 'Fecha de Inicio', value: 'name', sortable: false },
  { name: 'Fecha Fin', value: 'name', sortable: false },
  { name: 'Estatus', value: 'name', sortable: false },
  { name: 'Anualidad', value: 'name', sortable: false },
  { name: 'Cant servicios', value: 'name', sortable: false },
];

export const multiplePaymentsTableHeader = [
  { name: 'Método', value: 'name', sortable: false },
  { name: 'Monto USD', value: 'name', sortable: false },
  { name: 'Monto Bs', value: 'name', sortable: false },
  { name: 'IGTF', value: 'name', sortable: false },
  { name: 'Monto Total USD', value: 'name', sortable: false },
  { name: 'Monto Total Bs', value: 'name', sortable: false },
  { name: 'Referencia', value: 'name', sortable: false },
  { name: 'Lote de transacción', value: 'name', sortable: false },
  { name: 'Comprobante', value: 'name', sortable: false },
  { name: 'Observacion', value: 'name', sortable: false },
  { name: 'Accion', value: 'name', sortable: false },
];

export const nextQuotaTableHeader = [
  { name: 'Cuota', value: 'name', sortable: false },
  { name: 'Fecha', value: 'name', sortable: false },
  { name: 'Monto USD', value: 'name', sortable: false },
  { name: 'Monto Bs', value: 'name', sortable: false },
];

export const validatePaymentsTableHeader = [
  { name: 'Editar', value: 'edit', sortable: false },
  { name: 'Nro Orden', value: 'order', sortable: false },
  { name: 'Fecha de Pago', value: 'date', sortable: false },
  { name: 'Asesor Responsable', value: 'seller', sortable: false },
  { name: 'Monto Facturado USD', value: 'totalAmount', sortable: false },
  { name: 'Tipo de pago', value: 'paymentType', sortable: false },
  { name: 'Monto Ingresado USD', value: 'amount', sortable: false },
  { name: 'Monto Ingresado Bs', value: 'amountBs', sortable: false },
  { name: 'Método de Pago', value: 'method', sortable: false },
  { name: 'Referencia', value: 'reference', sortable: false },
  { name: 'Lote de transacción', value: 'transactionBatch', sortable: false },
  { name: 'Titular', value: 'owner', sortable: false },
  { name: 'Observación', value: 'owner', sortable: false },
  { name: 'Comprobante', value: 'evidence', sortable: false },
  { name: 'Concepto', value: 'type', sortable: false },
  { name: 'Estatus de Pago', value: 'statusDetail', sortable: false },
  { name: 'Acción', value: 'action', sortable: false },
];

export const casheaLinkDeletedOrdersTableHeader = [
  { name: 'N° Orden', value: 'membershipId', sortable: false },
  { name: 'Estatus de la Orden', value: 'statusDescription', sortable: false },
  { name: 'Nombre', value: 'firstName', sortable: false },
  { name: 'Apellido', value: 'lastName', sortable: false },
  { name: 'Placa', value: 'plate', sortable: false },
  { name: 'Referencia Cashea', value: 'casheaRef', sortable: false },
  { name: 'Estatus Cashea', value: 'casheaStatus', sortable: false },
];

export const advancedPaymentsTableHeader = [
  { name: 'Nro. Orden', value: 'order', sortable: false },
  { name: 'Fecha de Carga', value: 'date', sortable: false },
  { name: 'Fecha de Pago', value: 'date', sortable: false },
  { name: 'Asesor Responsable', value: 'seller', sortable: false },
  { name: 'Monto Ingresado USD', value: 'totalAmount', sortable: false },
  { name: 'Monto Ingresado Bs', value: 'totalAmount', sortable: false },
  { name: 'Método de Pago', value: 'method', sortable: false },
  { name: 'Referencia', value: 'reference', sortable: false },
  { name: 'Comprobante', value: 'evidence', sortable: false },
  { name: 'Tipo de Pago', value: 'evidence', sortable: false },
  { name: 'Referencia Cashea', value: 'evidence', sortable: false },
  { name: 'Estatus de Pago', value: 'owner', sortable: false },
  { name: 'Fecha de Registro de Pago', value: 'type', sortable: false },
  { name: 'Nombre del cliente', value: 'type', sortable: false },
  { name: 'Cédula del cliente', value: 'type', sortable: false },
  { name: 'Teléfono de contacto', value: 'type', sortable: false },
  { name: 'Acción', value: 'action', sortable: false },
];

export const paymentChangesTableHeader = [
  { name: 'Editar', value: 'edit', sortable: false },
  { name: 'Nro Orden', value: 'order', sortable: false },
  { name: 'Fecha de Pago', value: 'date', sortable: false },
  { name: 'Asesor Responsable', value: 'seller', sortable: false },
  { name: 'Monto Facturado USD', value: 'totalAmount', sortable: false },
  { name: 'Monto Ingresado USD', value: 'amount', sortable: false },
  { name: 'Vuelto a entregar USD', value: 'totalAmount', sortable: false },
  { name: 'Vuelto a entregar Bs', value: 'amountBs', sortable: false },
  { name: 'Método de vuelto', value: 'method', sortable: false },
  { name: 'Datos del vuelto', value: 'method', sortable: false },
  { name: 'Tipo de vuelto', value: 'method', sortable: false },
  { name: 'Concepto', value: 'type', sortable: false },
  { name: 'Observación', value: 'observation', sortable: false },
  { name: 'Acción', value: 'action', sortable: false },
];

export const GoalsHeader = [
  { name: 'Año', value: 'name', sortable: false },
  { name: 'Mes', value: 'name', sortable: false },
  { name: 'Meta Grupal', value: 'state', sortable: false },
  { name: 'Meta Individual', value: 'phone', sortable: false },
];

export const fleetLoadDetailMockup = [
  {
    name1: 'CD001',
    name2: 'Técnica',
    name3: 'Planes',
    name4: '1.200$',
    name5: 'Financiado mensual',
    name6: '31/03/2023',
    name7: '31/03/2024',
    name8: 'Teléfono',
    name9: '15',
    name10: 'Activa',
  },
  {
    name1: 'CD001',
    name2: 'Técnica',
    name3: 'Planes',
    name4: '1.200$',
    name5: 'Financiado mensual',
    name6: '31/03/2023',
    name7: '31/03/2024',
    name8: 'Teléfono',
    name9: '15',
    name10: 'Activa',
  },
  {
    name1: 'CD001',
    name2: 'Técnica',
    name3: 'Planes',
    name4: '1.200$',
    name5: 'Financiado mensual',
    name6: '31/03/2023',
    name7: '31/03/2024',
    name8: 'Teléfono',
    name9: '15',
    name10: 'Activa',
  },
];

export const fleetLoadMockup = [
  {
    id: '1',
    name: 'MANUEL HERNANDEZ',
    code: '1234 567 789',
    status: 'MIRANDA',
    load: 'ACTIVO',
    modified: '21/04/23 11:01:43',
    actions: '21/04/23 11:01:43',
  },
  {
    id: '2',
    name: 'MANUEL HERNANDEZ',
    code: '1234 567 789',
    status: 'MIRANDA',
    load: 'ACTIVO',
    modified: '21/04/23 11:01:43',
    actions: '21/04/23 11:01:43',
  },
  {
    id: '3',
    name: 'MANUEL HERNANDEZ',
    code: '1234 567 789',
    status: 'MIRANDA',
    load: 'ACTIVO',
    modified: '21/04/23 11:01:43',
    actions: '21/04/23 11:01:43',
  },
  {
    id: '4',
    name: 'MANUEL HERNANDEZ',
    code: '1234 567 789',
    status: 'MIRANDA',
    load: 'ACTIVO',
    modified: '21/04/23 11:01:43',
    actions: '21/04/23 11:01:43',
  },
];

export const craneProvidersMockup = [
  {
    name: 'TRANSPORTE MACHADO 1974, C.A',
    contact: 'MANUEL HERNANDEZ',
    phone: '1234 567 789',
    state: 'MIRANDA',
    status: 'ACTIVO',
    edit: '',
  },
  {
    name: 'TRANSPORTE MACHADO 1974, C.A',
    contact: 'MANUEL HERNANDEZ',
    phone: '1234 567 789',
    state: 'MIRANDA',
    status: 'ACTIVO',
    edit: '',
  },
  {
    name: 'TRANSPORTE MACHADO 1974, C.A',
    contact: 'MANUEL HERNANDEZ',
    phone: '1234 567 789',
    state: 'MIRANDA',
    status: 'ACTIVO',
    edit: '',
  },
  {
    name: 'TRANSPORTE MACHADO 1974, C.A',
    contact: 'MANUEL HERNANDEZ',
    phone: '1234 567 789',
    state: 'MIRANDA',
    status: 'ACTIVO',
    edit: '',
  },
  {
    name: 'TRANSPORTE MACHADO 1974, C.A',
    contact: 'MANUEL HERNANDEZ',
    phone: '1234 567 789',
    state: 'MIRANDA',
    status: 'ACTIVO',
    edit: '',
  },
  {
    name: 'TRANSPORTE MACHADO 1974, C.A',
    contact: 'MANUEL HERNANDEZ',
    phone: '1234 567 789',
    state: 'MIRANDA',
    status: 'ACTIVO',
    edit: '',
  },
  {
    name: 'TRANSPORTE MACHADO 1974, C.A',
    contact: 'MANUEL HERNANDEZ',
    phone: '1234 567 789',
    state: 'MIRANDA',
    status: 'ACTIVO',
    edit: '',
  },
  {
    name: 'TRANSPORTE MACHADO 1974, C.A',
    contact: 'MANUEL HERNANDEZ',
    phone: '1234 567 789',
    state: 'MIRANDA',
    status: 'ACTIVO',
    edit: '',
  },
  {
    name: 'TRANSPORTE MACHADO 1974, C.A',
    contact: 'MANUEL HERNANDEZ',
    phone: '1234 567 789',
    state: 'MIRANDA',
    status: 'ACTIVO',
    edit: '',
  },
  {
    name: 'TRANSPORTE MACHADO 1974, C.A',
    contact: 'MANUEL HERNANDEZ',
    phone: '1234 567 789',
    state: 'MIRANDA',
    status: 'ACTIVO',
    edit: '',
  },
  {
    name: 'TRANSPORTE MACHADO 1974, C.A',
    contact: 'MANUEL HERNANDEZ',
    phone: '1234 567 789',
    state: 'MIRANDA',
    status: 'ACTIVO',
    edit: '',
  },
];

export const bikeMockup = [
  {
    name: 'Jose Luis Perez Rodriguez',
    cedula: '1234 567 789',
    phone: '1234 567 789',
    plate: 'AH74VF',
    state: 'MIRANDA',
    creationDate: '12/03/2023',
  },
  {
    name: 'Jose Luis Perez Rodriguez',
    cedula: '1234 567 789',
    phone: '1234 567 789',
    plate: 'AH74VF',
    state: 'MIRANDA',
    creationDate: '12/03/2023',
  },
  {
    name: 'Jose Luis Perez Rodriguez',
    cedula: '1234 567 789',
    phone: '1234 567 789',
    plate: 'AH74VF',
    state: 'MIRANDA',
    creationDate: '12/03/2023',
  },
  {
    name: 'Jose Luis Perez Rodriguez',
    cedula: '1234 567 789',
    phone: '1234 567 789',
    plate: 'AH74VF',
    state: 'MIRANDA',
    creationDate: '12/03/2023',
  },
  {
    name: 'Jose Luis Perez Rodriguez',
    cedula: '1234 567 789',
    phone: '1234 567 789',
    plate: 'AH74VF',
    state: 'MIRANDA',
    creationDate: '12/03/2023',
  },
  {
    name: 'Jose Luis Perez Rodriguez',
    cedula: '1234 567 789',
    phone: '1234 567 789',
    plate: 'AH74VF',
    state: 'MIRANDA',
    creationDate: '12/03/2023',
  },
  {
    name: 'Jose Luis Perez Rodriguez',
    cedula: '1234 567 789',
    phone: '1234 567 789',
    plate: 'AH74VF',
    state: 'MIRANDA',
    creationDate: '12/03/2023',
  },
];

export const providersTablesMockup = [
  {
    name: 'Rubeeeen',
    contact: '4142662382',
    region: 'Caracas',
    state: 'Miranda',
  },
  {
    name: 'Rubeeeen',
    contact: '4142662382',
    region: 'Caracas',
    state: 'Miranda',
  },
  {
    name: 'Rubeeeen',
    contact: '4142662382',
    region: 'Caracas',
    state: 'Miranda',
  },
  {
    name: 'Rubeeeen',
    contact: '4142662382',
    region: 'Caracas',
    state: 'Miranda',
  },
  {
    name: 'Rubeeeen',
    contact: '4142662382',
    region: 'Caracas',
    state: 'Miranda',
  },
];

export const fleetsTablesMockup = [
  {
    transport: 'Grua',
    model: 'Carrito',
    brand: 'Encava',
    plate: 'AH74VF',
    year: '2009',
    purchaseDate: '17/02/2020 17:02:30',
  },
  {
    transport: 'Grua',
    model: 'Carrito',
    brand: 'Encava',
    plate: 'AH74VF',
    year: '2009',
    purchaseDate: '17/02/2020 17:02:30',
  },
  {
    transport: 'Grua',
    model: 'Carrito',
    brand: 'Encava',
    plate: 'AH74VF',
    year: '2009',
    purchaseDate: '17/02/2020 17:02:30',
  },
  {
    transport: 'Grua',
    model: 'Carrito',
    brand: 'Encava',
    plate: 'AH74VF',
    year: '2009',
    purchaseDate: '17/02/2020 17:02:30',
  },
  {
    transport: 'Grua',
    model: 'Carrito',
    brand: 'Encava',
    plate: 'AH74VF',
    year: '2009',
    purchaseDate: '17/02/2020 17:02:30',
  },
];

export const multipleMembershipsTableHeader = [
  { name: 'Año del vehículo', value: 'name', sortable: false },
  { name: 'Clase de vehículo *', value: 'name', sortable: false },
  { name: 'Blindaje', value: 'name', sortable: false },
  { name: 'Tipo de código', value: 'name', sortable: false },
  { name: 'Código', value: 'name', sortable: false },
  { name: 'Plan', value: 'name', sortable: false },
  { name: 'RCV', value: 'name', sortable: false },
  { name: 'Monto $', value: 'name', sortable: false },
  { name: 'Monto Bs', value: 'name', sortable: false },
  { name: 'Accion', value: 'name', sortable: false },
];

export const multipleVehiclesTableHeader = [
  { name: 'Membresia ', value: 'name', sortable: false },
  { name: 'Cliente ', value: 'name', sortable: false },
  { name: 'Vehículo', value: 'name', sortable: false },
  { name: 'Accion ', value: 'name', sortable: false },
];

export const multipleRenewalTableHeader = [
  { name: 'Acciones ', value: 'name', sortable: false },
  { name: 'Nro. Orden ', value: 'name', sortable: false },
  { name: 'Plan', value: 'name', sortable: false },
  { name: 'KM Plan ', value: 'name', sortable: false },
  { name: 'Servicio de grúa extendida', value: 'name', sortable: false },
  { name: 'Año Vehículo', value: 'name', sortable: false },
  { name: 'Nivel de Siniestralidad', value: 'name', sortable: false },
  { name: 'Cantidad Serv. Grúa', value: 'name', sortable: false },
  { name: 'Blindaje', value: 'name', sortable: false },
  { name: 'Tarjeta RCV', value: 'name', sortable: false },
  { name: 'Descuento de renov', value: 'name', sortable: false },
  { name: '% recarga o descuento', value: 'name', sortable: false },
  { name: 'RCV', value: 'name', sortable: false },
  { name: 'Uso del Vehículo', value: 'name', sortable: false },
  { name: 'Código de descuento', value: 'name', sortable: false },
  { name: 'Precio Renovación USD', value: 'name', sortable: false },
  { name: 'Precio Renovación Bs', value: 'name', sortable: false },
  { name: 'Canal de Ventas', value: 'name', sortable: false },
  { name: 'Cliente', value: 'name', sortable: false },
  { name: 'Placa', value: 'name', sortable: false },
  { name: 'Marca', value: 'name', sortable: false },
  { name: 'Modelo', value: 'name', sortable: false },
  { name: 'Cédula', value: 'name', sortable: false },
  { name: 'Teléfono', value: 'name', sortable: false },
  { name: 'Correo', value: 'name', sortable: false },
  { name: 'Cedula', value: 'name', sortable: false },
  { name: 'Carnet de Circulacion', value: 'name', sortable: false },
  { name: 'Accion', value: 'name', sortable: false },
  { name: 'Edicion RCV', value: 'name', sortable: false },
];

export const multipleRenewalsPaymentTableHeader = [
  { name: 'Membresia', value: 'name', sortable: false },
  { name: 'Cliente ', value: 'name', sortable: false },
  { name: 'Vehículo ', value: 'name', sortable: false },
];

export const updateHistoryTableHeader = [
  { name: 'Fecha y hora del cambio', value: 'name', sortable: false },
  { name: 'Asesor', value: 'name', sortable: false },
  { name: 'N. Orden', value: 'state', sortable: false },
  { name: 'Asesor Responsable', value: 'phone', sortable: false },
  { name: 'Campo modificado', value: 'name', sortable: false },
  { name: 'Dato anterior', value: 'state', sortable: false },
  { name: 'Dato actualizado', value: 'phone', sortable: false },
];

/** Catálogo geográfico (Parámetros): columnas compartidas; el padre define datos y etiqueta de hijos */
export const geographicStatesTableHeader = [
  { name: 'NOMBRE', value: 'name', sortable: false },
  { name: 'REGISTROS HIJOS', value: 'childCount', sortable: false },
  { name: 'ESTATUS', value: 'status', sortable: false },
  { name: 'ACCIONES', value: 'actions', sortable: false },
];

export const geographicCitiesTableHeader = [
  { name: 'NOMBRE', value: 'name', sortable: false },
  { name: 'ESTADO', value: 'belongsTo', sortable: false },
  { name: 'REGISTROS HIJOS', value: 'childCount', sortable: false },
  { name: 'ESTATUS', value: 'status', sortable: false },
  { name: 'ACCIONES', value: 'actions', sortable: false },
];

export const geographicMunicipalitiesTableHeader = [
  { name: 'NOMBRE', value: 'name', sortable: false },
  { name: 'CIUDAD', value: 'belongsTo', sortable: false },
  { name: 'ESTADO', value: 'stateBelongsTo', sortable: false },
  { name: 'ESTATUS', value: 'status', sortable: false },
  { name: 'ACCIONES', value: 'actions', sortable: false },
];

/** Catálogo vehicular (Parámetros): Tipos / Marcas / Modelos */
export const vehicularTypesTableHeader = [
  { name: 'NOMBRE TIPO', value: 'name', sortable: false },
  { name: 'CLASE', value: 'vehicleClass', sortable: false },
  { name: 'ESTADO', value: 'status', sortable: false },
  { name: 'ACCIONES', value: 'actions', sortable: false },
];

export const vehicularBrandsTableHeader = [
  { name: 'NOMBRE MARCA', value: 'name', sortable: false },
  { name: 'REGISTROS HIJOS', value: 'childCount', sortable: false },
  { name: 'ESTADO', value: 'status', sortable: false },
  { name: 'ACCIONES', value: 'actions', sortable: false },
];

export const vehicularModelsTableHeader = [
  { name: 'NOMBRE MODELO', value: 'name', sortable: false },
  { name: 'MARCA', value: 'brandName', sortable: false },
  { name: 'ESTADO', value: 'status', sortable: false },
  { name: 'ACCIONES', value: 'actions', sortable: false },
];

export const commercialTableHeader = [
  { name: 'NOMBRE', value: 'name', sortable: false },
  { name: 'NOMBRE ABREVIADO', value: 'shortName', sortable: false },
  { name: 'CORRELATIVO', value: 'qrId', sortable: false },
  { name: 'LINKS', value: 'links', sortable: false },
  { name: 'CÓDIGOS QR', value: 'qrCodes', sortable: false },
  { name: 'ESTADO', value: 'isActive', sortable: false },
  { name: 'ACCIONES', value: 'actions', sortable: false },
];

export const surchargesTableHeader = [
  { name: 'CANAL / CONTEXTO', value: 'saleChannel', sortable: false },
  { name: 'TIPO AFILIACIÓN', value: 'contractTypes', sortable: false },
  { name: 'RECARGO SINIESTRO', value: 'useRenewSurcharge', sortable: false },
  {
    name: 'DESC. SINIESTRO/RENOV. ANTICIPADA',
    value: 'useRenewDiscount',
    sortable: false,
  },
  { name: 'NOTA / MOTIVO', value: 'description', sortable: false },
  { name: 'ESTADO', value: 'isActive', sortable: false },
  { name: 'ACCIONES', value: 'actions', sortable: false },
];

export const discountsTableHeader = [
  { name: 'CÓDIGO', value: 'discountCode', sortable: false },
  { name: 'DESCRIPCIÓN CAMPAÑA', value: 'description', sortable: false },
  { name: 'VIGENCIA', value: 'startDate', sortable: false },
  { name: 'LANDINGS', value: 'landings', sortable: false },
  { name: 'ESTADO', value: 'status', sortable: false },
  { name: 'ACCIONES', value: 'actions', sortable: false },
];

export const campaignTableHeader = [
  { name: 'CAMPAÑA', value: 'campaignName', sortable: false },
  { name: 'DÍAS ACTIVACIÓN', value: 'delay', sortable: false },
  { name: 'VIGENCIA', value: 'validity', sortable: false },
  { name: 'ESTADO', value: 'isActive', sortable: false },
  { name: 'NOTA', value: 'note', sortable: false },
  { name: 'ACCIONES', value: 'actions', sortable: false },
];
